"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogTrack = void 0;
exports.getTimeTrackList = getTimeTrackList;
exports.logTimeTrack = logTimeTrack;
exports.pageLogTrack = pageLogTrack;

var _la = _interopRequireDefault(require("./la"));

var _env = require("../env");

var _common = require("../common");

var _storage = _interopRequireDefault(require("../storage"));

var _uuidv = _interopRequireDefault(require("../uuid/uuidv4.min"));

var _IGC_JS2Native = require("../IGC_JS2Native");

var _semver = require("../semver");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file Log
 * @author qiaogang
 * @date 2019-12-12
 */

/**
 * 日志统计模块
 * 内置：大得到埋点
 */
var UUID_KEY = 'uuid';
var LogTrack = {
  _uuid: '',
  dictionary: {},
  _config: {
    dedaoLog: true,
    dedaoInit: false
  },
  startTime: Date.now(),
  _paramsOptions: {},

  /**
   * 配置 Log
   * @param {Object=} options
   * @param {boolean=} options.debug 是否开启 debug 日志（神策 debug 日志），默认 false
   * @param {boolean=} options.dedaoLog 是否发送得到日志，默认 true
   * @returns {LogTrack}
   */
  config: function config() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var debug = options.debug,
        dedaoLog = options.dedaoLog,
        paramsOptions = options.paramsOptions;

    if (!(0, _common.isNil)(debug)) {
      this._config.debugMode = debug;
    }

    if (!(0, _common.isNil)(dedaoLog)) {
      this._config.dedaoLog = dedaoLog;
    }

    if (!(0, _common.isNil)(paramsOptions)) {
      this._paramsOptions = paramsOptions;
    }

    return this;
  },

  /**
   * 初始化各种日志组件
   * @param {Object} options
   * @returns {LogTrack}
   */
  init: function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dedaoLog = this._config.dedaoLog;

    var uuid = _storage["default"].getItem(UUID_KEY);

    if ((0, _common.isNil)(uuid)) {
      uuid = (0, _uuidv["default"])();

      _storage["default"].setItem(UUID_KEY, uuid);
    }

    this._uuid = uuid;

    if (dedaoLog) {
      _la["default"].init();

      this._config.dedaoInit = true;
    }

    return this;
  },

  /**
   * 发送日志
   * 默认情况下神策的全埋点会发送页面访问日志，如果需要特定埋点需要调用该方法
   * @param {Object} options 日志字段
   * @param {string=} trackName 事件名称，选填。如果不填，则统计进 Web 元素点击。
   * returns {LogTrack}
   */
  track: function track() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var trackName = arguments.length > 1 ? arguments[1] : undefined;
    var setRefer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var routes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var RCODE_KEY = 'igcReCode'; // 同步获取用户信息

    (0, _common.getUserInfo)().then(function (_ref) {
      var appUserPid = _ref.appUserPid,
          appDeviceKey = _ref.appDeviceKey;
      var currentLocationSearchParams = new URLSearchParams(location.search);
      var from = location.search.match(/[&|?]from=([^&]*)/);
      var igc_from = location.search.match(/[&|?]igc_from=([^&]*)/);
      var rcode = currentLocationSearchParams.get(RCODE_KEY);
      var _options$$el = options.$el,
          $el = _options$$el === void 0 ? {} : _options$$el,
          event_type = options.event_type;
      var urlPath = location.origin + location.pathname;
      var openLocation = _env.env.isApp ? 'APP' : 'APP外';
      var _did = appDeviceKey;

      var _pid = appUserPid ? appUserPid : _this._uuid.replace(/-/g, '');

      var eventType = trackName || 'click';
      var refer_page_name = '未知页面';
      var refer_url = '未知url';
      var session_id = '未知';
      var defaultParams = {
        // 为 h5 项目分配的 ev，必传
        'ev': "sndd_sensor_".concat(eventType),
        // 定位具体某个用户的 uuid，必传
        'sid': _this._uuid.replace(/-/g, ''),
        // 签名，必传
        'wid': 'Bo56mbY2mr7eKHDK',
        'did': _did,
        'uid': _pid,
        // APP 内 用 userPid，APP 外用 uuid
        'h5_open_location': openLocation,
        'tech_type': 'h5',
        't': Date.now(),
        // 时间戳
        'eurl': urlPath,
        // url
        'url_path': urlPath,
        'url': location.href,
        'os': _env.env.OSType,
        // 操作系统类型
        'browser_env': _env.env.environment || _env.env.browser,
        // environment 浏览器为空 读取后面获取浏览器类型
        'device_type': _env.env.mobileDeviceType,
        // 元素名称
        'element_name': $el.innerText || $el.value || $el.name || '',
        'title': document.title,
        'from': igc_from && igc_from[1] || from && from[1] || '',
        'rcode': rcode,
        'event_type': eventType,
        'refer_page_name': refer_page_name,
        'refer_url': refer_url,
        'session_id': session_id,
        'trace_time': Date.now(),
        'app_server': _env.env.isApp ? _env.env.appVer : '',
        'auto_refer_url': '未知url',
        'auto_refer_page_name': '未知页面',
        'ua': window.navigator.userAgent,
        'page_mark': '',
        // 页面标示
        'duration': 0 // 页面停留时长

      };
      defaultParams = (0, _common.merge)(defaultParams, _this._paramsOptions);

      if (setRefer) {
        _this.getRouterDictionary(routes);

        _this.addSinglePageEvent(function (t) {
          var paramsAuto = JSON.parse(JSON.stringify(defaultParams));
          paramsAuto.url_path = location.origin + location.pathname;
          paramsAuto.eurl = location.origin + location.pathname;
          paramsAuto.url = location.href;
          paramsAuto.event_type = 'autoTrack';
          paramsAuto.ev = 'sndd_sensor_autoTrack';
          paramsAuto.t = Date.now();
          paramsAuto.trace_time = Date.now();
          paramsAuto.page_mark = "".concat(location.href).concat(_pid).concat(Date.now());
          paramsAuto.duration = ((Date.now() - _this.startTime) / 1000).toFixed(0);
          _this.startTime = Date.now(); // 页面路由切换自动上报

          if (!t) {
            _this.getDataReportInfo(function (data) {
              paramsAuto.auto_refer_url = data.refer_url;
              paramsAuto.auto_refer_page_name = data.refer_page_name;

              _this.getSessionId().then(function (sid) {
                paramsAuto.session_id = sid;

                _this.report(paramsAuto);
              });
            });
          } else {
            paramsAuto.auto_refer_url = t;
            paramsAuto.auto_refer_page_name = _this.getPageName();
            window.refer_page_name = paramsAuto.auto_refer_page_name;

            _this.getSessionId().then(function (sid) {
              paramsAuto.session_id = sid;
              defaultParams.session_id = sid;

              _this.report(paramsAuto);
            });
          }
        }, function () {
          var prevParams = JSON.parse(JSON.stringify(defaultParams));
          prevParams.page_mark = "".concat(location.href).concat(_pid).concat(Date.now());
          prevParams.duration = ((Date.now() - _this.startTime) / 1000).toFixed(0);
          _this.startTime = Date.now();

          _this.report(prevParams);
        }); // 页面时长滚动上报


        var scrollFn = throttle(function () {
          var scrollLogParams = {};
          scrollLogParams.page_mark = "".concat(location.href).concat(_pid).concat(Date.now());
          scrollLogParams.duration = ((Date.now() - _this.startTime) / 1000).toFixed(0);
          var params = (0, _common.defaults)(scrollLogParams, defaultParams);
          _this.startTime = Date.now();

          _this.report(params);
        }, 500);
        document.removeEventListener('scroll', scrollFn);
        document.addEventListener('scroll', scrollFn);
      } else {
        var params = (0, _common.defaults)(options, defaultParams);

        _this.getDataReportInfo(function (data) {
          params.refer_url = data.refer_url;
          params.refer_page_name = data.refer_page_name;

          _this.report(params);
        });
      }
    });
    return this;
  },
  // 同步获取埋点所需的 refer 数据 --- 3.17.0 版本升级后才能使用 getDataReportInfo 这个方法
  getDataReportInfo: function getDataReportInfo(fn) {
    if (_env.env.isApp && (0, _semver.compareVersion)(_env.env.appVer, '3.17.0') >= 0) {
      // 同步获取埋点所需的 refer 数据
      (0, _IGC_JS2Native.JS2Native)({
        name: 'getDataReportInfo'
      }).then(function (res) {
        window.refer_page_name = res.data.refer_page_name;
        typeof fn === 'function' && fn(res.data);
      });
    } else {
      typeof fn === 'function' && fn({
        'refer_url': '未知url',
        'refer_page_name': '未知页面'
      });
    }
  },
  // 获取埋点所需sessionId
  getSessionId: function getSessionId(fn) {
    return new Promise(function (resolve, reject) {
      if (_env.env.isApp && (0, _semver.compareVersion)(_env.env.appVer, '3.20.0') >= 0) {
        // 同步获取埋点所需的 SessionId 数据
        (0, _IGC_JS2Native.JS2Native)({
          name: 'getSessionId'
        }).then(function (res) {
          var sid = res.data.session_id;
          typeof fn == 'function' && fn(sid);
          resolve(sid);
        });
      } else {
        typeof fn == 'function' && fn('未知');
        return resolve('未知');
      }
    });
  },
  // 客户端所需refer
  setReferInfo: function setReferInfo() {
    if (_env.env.isApp && (0, _semver.compareVersion)(_env.env.appVer, '3.20.0') >= 0) {
      (0, _IGC_JS2Native.JS2Native)({
        name: 'setReferInfo'
      });
    }
  },

  /**
   * 上报数据到大得到（将上报动作单独抽出）
   * @param {Object} defaultParams 日志字段
   */
  report: function report(params) {
    var _this$_config = this._config,
        dedaoLog = _this$_config.dedaoLog,
        dedaoInit = _this$_config.dedaoInit;

    if (dedaoLog && window._la && dedaoInit) {
      var laLogs = [];

      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          var val = params[key];
          val = (0, _common.isNil)(val) ? '' : val;
          laLogs.push([key, val]);
        }
      }

      window._la.push.apply(null, laLogs);
    }
  },
  getUUID: function getUUID() {
    return this._uuid;
  },
  addEvent: function addEvent(a, fn) {
    var ev = window.addEventListener;
    ev.apply(window, arguments);
    fn && fn();
  },

  /**
   * 
   * @param {*} fn 跳转后回调
   * @param {*} prevFn 跳转前方法处理
   */
  addSinglePageEvent: function addSinglePageEvent(fn, prevFn) {
    var href = location.href,
        // 上一页
    pushState = window.history.pushState,
        replaceState = window.history.replaceState,
        that = this,
        record_url;

    window.history.pushState = function () {
      // 跳转前处理
      typeof prevFn === 'function' && prevFn();
      that.setReferInfo();
      pushState.apply(window.history, arguments);
      typeof fn === 'function' && fn(href);
      href = location.href;
    };

    window.history.replaceState = function () {
      // 跳转前处理
      typeof prevFn === 'function' && prevFn();
      that.setReferInfo();
      replaceState.apply(window.history, arguments);
      typeof fn == 'function' && fn(href);
      href = location.href;
    };

    var a = pushState ? 'popstate' : 'hashchange';
    this.addEvent(a, function () {
      var prevPage = document.referrer;

      if (record_url != prevPage) {
        typeof fn == 'function' && fn(prevPage);
        record_url = prevPage;
      }

      that.setReferInfo();
    });
  },
  getRouterDictionary: function getRouterDictionary(arr) {
    var _this2 = this;

    var pathOne = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    arr.forEach(function (e) {
      var path = e.path;

      if (path.substr(0, 1) != '/' && pathOne.substr(pathOne.length - 1) != '/') {
        path = "".concat(pathOne, "/").concat(path);
      } else {
        path = "".concat(pathOne).concat(path);
      }

      if (e.children && e.children.length > 0) {
        _this2.getRouterDictionary(e.children, e.path);
      }

      _this2.dictionary[path] = e.page_name || '未知页面';
    });
  },
  // 获取页面名称
  getPageName: function getPageName() {
    var href = location.href;
    var pageKey = href.split(window.location.host)[1];
    var refer_page_name = this.dictionary[pageKey] || '未知页面';
    return refer_page_name;
  }
}; // 日志计时

exports.LogTrack = LogTrack;
var timeTrackList = [];

function logTimeTrack(endName) {
  var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var start = window.__igc_page_start__;

  if (typeof start !== 'undefined') {
    var now = endTime;
    timeTrackList.push({
      name: endName,
      duration: now - start
    });
  }
}

function getTimeTrackList() {
  return timeTrackList;
}

document.addEventListener('DOMContentLoaded', function () {
  logTimeTrack('DOMContentLoaded');
});
window.addEventListener('load', function () {
  var end = window.__igc_page_end__;

  if (typeof end !== 'undefined') {
    logTimeTrack('pageEnd', end);
  }

  logTimeTrack('load');
  var list = timeTrackList;
  var props = {};
  list.forEach(function (value) {
    props[value.name] = value.duration;
  });
  LogTrack.track(props, 'pageLoadTime');
}); // 监控页面加载日志上报

var pageLog = {
  _page_start: window.__igc_page_start__ || '',
  _page_url: window.location.href || ''
};
var timer = null;

function pageLogTrack(name) {
  timer && clearTimeout(timer);
  pageLog[name] = Date.now();
  timer = setTimeout(function () {
    pageLog._page_end = window.__igc_page_end__ || '';
    pageLog._page_push = window.__igc_page_push__ || '';
    LogTrack.track(pageLog, 'pageLog');
  }, 10000);
}

function throttle(func, wait) {
  var timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}